import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  getCurrentImportantDate as apiGetCurrentImportantDate,
  getCurrentPedagogicalYear as apiGetCurrentPedagogicalYear,
  getRegularTerm as apiGetRegularTerm,
} from "../api/kindergartenApi";
import ImportantDate from "../models/ImportantDate/ImportantDate";
import RegularTerm from "../models/ImportantDate/RegularTerm";
import PedagogicalYear from "../models/PedagogicalYear/PedagogicalYear";

interface PedagogicalYearState {
  currentPedagogicalYear: PedagogicalYear;
  currentImportantDate: ImportantDate;
  regularTerm: RegularTerm;
}

let initialState: PedagogicalYearState = {
  currentPedagogicalYear: {} as PedagogicalYear,
  currentImportantDate: {} as ImportantDate,
  regularTerm: {} as RegularTerm,
};

export const getCurrent = createAsyncThunk(
  "pedagogicalYear/getCurrent",
  async () => {
    const response = await apiGetCurrentPedagogicalYear();
    return response;
  }
);

export const getCurrentImportantDate = createAsyncThunk(
  "pedagogicalYear/getCurrentImportantDate",
  async () => {
    const response = await apiGetCurrentImportantDate();
    return response;
  }
);

export const getRegularTerm = createAsyncThunk(
  "pedagogicalYear/getgetRegularTerm",
  async () => {
    const response = await apiGetRegularTerm();
    return response;
  }
);

const pedagogicalYearSlice = createSlice({
  name: "pedagogicalYear",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCurrent.fulfilled, (state, { payload }) => {
        state.currentPedagogicalYear = {
          ...payload,
          dateFrom: new Date(payload.dateFrom),
          dateTo: new Date(payload.dateTo),
        };
      })
      .addCase(getCurrentImportantDate.fulfilled, (state, { payload }) => {
        state.currentImportantDate = {
          ...payload,
        };
      })
      .addCase(getRegularTerm.fulfilled, (state, { payload }) => {
        state.regularTerm = {
          ...payload,
        };
      });
  },
});

export default pedagogicalYearSlice.reducer;
